import React from "react";

import s from "./ConfigColorItem.module.scss";

export const ConfigColorItem = ({ ...props }) => {
  const { onChangeItem, item, activeId } = props;

  const isActive = activeId === item.id ? s.active : "";
  const classNameSmall =
    item.name.length >= 9 ? `${s.item_name} ${s.item_name_small}` : s.item_name;

  return (
    <div
      key={item.id}
      className={`${s.item} ${isActive}`}
      onClick={() => {
        onChangeItem({
          id: item.id,
          name: item.name,
          assetId: item.assetId || item.materialName,
        });
      }}
    >
      <div className={s.item_img_wrap}>
        {item.imgUrl ? (
          <div
            className={s.item_img}
            style={{ backgroundImage: `url(${item.imgUrl})` }}
          />
        ) : (
          <div className={`${s.item_img} ${s.item_img_text}`}>
            {item.name}
          </div>
        )}
      </div>
      <div className={classNameSmall}>
        {item.name}
      </div>
    </div>
  );
};
